export enum TfaCodes {
  RequiresSetup,
  RequiresVerification
}

export type LoginResponse = {
  data: {
    code: TfaCodes
  }
}